/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* Licensed under the MIT License. See LICENSE.md in the project root for license terms.
*--------------------------------------------------------------------------------------------*/

import { SvgUpload } from "@itwin/itwinui-icons-react";
import { Text } from "@itwin/itwinui-react";
import styles from "./FileUploadPlaceholder.module.css";

export const FileUploadPlaceholder = () => {
  return <div className={styles.placeholder}>
    <div className={styles.container}>

      <SvgUpload className={styles.icon} />

      <Text variant="subheading">Drag & Drop files here</Text>
    </div>
  </div>
}